export const salesTypeDictionary = {
  'Venda Direta': {
    labelValor: 'venda',
    valorPrincipal: 'valor_venda',
  },
  'Leilão - Santander': {
    labelValor: 'venda',
    valorPrincipal: 'valor_venda',
  },
  'Leilão - Caixa': {},
  'Concorrência Direta': {},
  'Terreno Sob Consulta': {},
}

export const discountText = value =>
  `Imóvel tem ${value}% de desconto para pagamento à vista;`

export const formatDate = (competitionDate, competitionHour) => {
  const [day, month, year] = competitionDate.split('/')
  return `${year}-${month}-${day}T${competitionHour}`
}
